module.exports = __webpack_public_path__ + "static/media/link2.8f17e12f.svg";